import { render } from "./ParkingSpaceSelectorModal.vue?vue&type=template&id=422d19b0&ts=true"
import script from "./ParkingSpaceSelectorModal.vue?vue&type=script&lang=ts"
export * from "./ParkingSpaceSelectorModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__